var map = {
	"./404.png": "8f20",
	"./Kami-back-null.png": "9865",
	"./Kami-back.png": "6dc4",
	"./Kami-icon-null.png": "fffa",
	"./Kami-icon.png": "c003",
	"./Received-icon.png": "321f",
	"./Recor-cion-select.png": "95f6",
	"./Summary-item-head-bottom.png": "aba4",
	"./Summary-item-head.png": "aebc",
	"./WeChat-icon.png": "8070",
	"./active-icons.png": "0e60",
	"./activity-banner.png": "b38a",
	"./activity-bottom-btn.png": "0b2f",
	"./activity-head-back.png": "1232",
	"./activity-head-bottom-back.png": "3fd1",
	"./activity-head-title-icon-left.png": "105a",
	"./activity-head-title-icon-right.png": "0f8e",
	"./activity-icon.png": "f424",
	"./activity-over-btn.png": "c777",
	"./add-icon.png": "baf9",
	"./addPatient-banner.png": "728e",
	"./addpatient-icon.png": "969e",
	"./address-back.png": "88c5",
	"./address-icon.png": "1d82",
	"./address-null-back.png": "c2cb",
	"./admission-active.png": "72bd",
	"./admission-banner.png": "ab61",
	"./admission-info-bannner.png": "e4a0",
	"./admission-success-icon.png": "d2c3",
	"./admission-tilte-back.png": "f384",
	"./after-icon.png": "94fe",
	"./agreement-back.png": "7436",
	"./appointment-head-back.png": "f78a",
	"./appointment-head-back2.png": "bf70",
	"./appointment-section-back.png": "8090",
	"./arrow_bottom_ion.png": "79a1",
	"./arrow_top_ion.png": "0e98",
	"./back-integer-icon.png": "aca7",
	"./blood-pressure-time-icon.png": "a2e4",
	"./cart-null-back.png": "cddc",
	"./cartshop-icon.png": "4812",
	"./case-history-img.png": "4238",
	"./casehistory-detail-back.png": "5f12",
	"./casehistory-title-icon.png": "139c",
	"./casehistory-title-moreicon.png": "7ac1",
	"./clinic-icon.png": "1561",
	"./clip-icon.png": "c24f9",
	"./close-icon.png": "b364",
	"./column-icon1.png": "2d46",
	"./column-icon2.png": "7876",
	"./column-icon3.png": "aaeb",
	"./comma-icon.png": "3b9a",
	"./commentOn-emtry.png": "deaf",
	"./consult-icon.png": "8030",
	"./contact-phone.png": "bdb7",
	"./costmor-icon.png": "85f0",
	"./current-regulation.png": "92a0",
	"./data-null.png": "3f3b",
	"./date-cion-empty.png": "933b",
	"./date-icon.png": "bc81",
	"./delete-icon.png": "4304",
	"./depositCard-icon.png": "d719",
	"./derault-avater.png": "e387",
	"./desc-title-back.png": "631c",
	"./detail-head-back-.png": "27ce",
	"./detail-head-back-man.png": "8e76",
	"./detail-head-back-woman.png": "e8b1",
	"./detail-head-name-back.png": "a692",
	"./detail-more.png": "abd3",
	"./dialog-banners.png": "fe98",
	"./distribution-goods-lable.png": "741c",
	"./distribution-goods-lablehot.png": "08cc",
	"./doctor-head-backleft.png": "ee58",
	"./doctor-head-backright.png": "d109",
	"./doctordetails-noData.png": "1b456",
	"./download-back.png": "ec2b",
	"./download-banner1.png": "b2df",
	"./download-banner2.png": "e9c2",
	"./download-btn-back.png": "8754",
	"./download-btn-icon.png": "b66f",
	"./download-icon.png": "02e7",
	"./download-tips.png": "8563",
	"./download-tips2.png": "15b6",
	"./ecg-detail-back-1.png": "3216",
	"./ecg-detail-back-2.png": "a5c2",
	"./ecg-detail-back-3.png": "3ef9",
	"./ecg-detail-back-4.png": "0686",
	"./ecg-detail-back-banner1.png": "5d0e",
	"./ecg-detail-back-banner2.png": "c738",
	"./ecg-detail-back-banner3.png": "9061",
	"./ecg-detail-back-banner4.png": "8dcd",
	"./ecg-putong-icon.png": "7eeb",
	"./ecg-weiji-icon.png": "1863",
	"./ecg-wufa-icon.png": "1038",
	"./ecg-yujin-icon.png": "ce7af",
	"./edit-cion.png": "8f18",
	"./edit-icon.png": "d2f3",
	"./emergencyContact.png": "fea7",
	"./emergencyContact2.png": "c683",
	"./evaluate-active-icon.png": "33e6",
	"./evaluate-anonymous-active.png": "1134",
	"./evaluate-anonymous.png": "d245",
	"./evaluate-icon.png": "4291",
	"./evaluate-upload-img.png": "8cb1",
	"./evalute-succes-back.png": "4316",
	"./evalute-success-icon.png": "930b",
	"./examinantion-main-index-back.png": "8d07",
	"./exanubabtuib-title.png": "afa4",
	"./existPatient-back.png": "afa7",
	"./feedback-head-icon.png": "4bd7",
	"./female.png": "e0a3",
	"./finnish-icon.png": "4e3f",
	"./float-aperture-back.png": "0f47",
	"./fold-bottom.png": "b9e3",
	"./fold-top.png": "757e",
	"./follow-see-detail-back.png": "1278",
	"./follow-status-icon1.png": "6baa",
	"./follow-status-icon2.png": "f266",
	"./follow-time-icon-active.png": "ef30",
	"./follow-time-icon.png": "1e70",
	"./follow-type1-active.png": "4cbe",
	"./follow-type1.png": "d86f",
	"./follow-type2-active.png": "44a8",
	"./follow-type2.png": "be8d",
	"./follow-type3-active.png": "9b0d",
	"./follow-type3.png": "acf0",
	"./gift-icon.png": "07ce",
	"./gift-img.png": "059b",
	"./gift-null-icon.png": "ca73",
	"./gift-title-back.png": "702d",
	"./go-kefu-icon.png": "8302",
	"./goods-discount-bg.png": "4ddc",
	"./goods-distribution.png": "1a11",
	"./group-member-icon.png": "ceb2",
	"./head-msg-back.png": "cc67",
	"./healthy-aritce-icon.png": "cacc",
	"./healthy-audio-icon-paly.png": "11da",
	"./healthy-audio-icon-stop.png": "b845",
	"./healthy-question-icon.png": "5ea7",
	"./healthy-status-icon.png": "28d7",
	"./healthy-status-icon2.png": "5d6b",
	"./healthy-tag-back.png": "9f42",
	"./healthy-tag-back2.png": "7d95",
	"./hosp-btn-icon.png": "9384",
	"./hosp-head-icon.png": "82708",
	"./hosp-icon.png": "d98e",
	"./hosp-subscribe-banner.png": "c9e8",
	"./hosp-subscribe-success-icon.png": "29c7",
	"./hospital-detail-head-back.png": "1d27",
	"./hospital-detail-head-container-back.png": "89ca",
	"./hospital-icon.png": "9961",
	"./hospitalization-icon.png": "4774",
	"./hotEvents-icon.png": "b8fc",
	"./im-artificial.png": "83fd",
	"./im-emtry.png": "cd5b",
	"./im-keywords-banner-back.png": "1475",
	"./im-selectPatient-icon.png": "fabd",
	"./img-label-back.png": "c9c5",
	"./img-label-icon.png": "0a18",
	"./incitated-icon.png": "6225",
	"./info-goods-icon.png": "8d17",
	"./inhandle-hosp-icon.png": "9588",
	"./input-icon.png": "94c3",
	"./integer-back.png": "2aa0",
	"./integral-icon.png": "e3ef",
	"./introduce-icon.png": "c431",
	"./invitation.png": "f140",
	"./invitation2.png": "4a05",
	"./invite-bacik.png": "2fa4",
	"./isnew_icon.png": "7f35",
	"./line-icon.png": "fd7a",
	"./make-hosp-icon.png": "a10b",
	"./male.png": "e93b",
	"./man-icon.png": "ceaa",
	"./message-empty.png": "8e8d",
	"./money-bg-icon.png": "8b26",
	"./money-bg-icon2.png": "5cf5",
	"./monitor-add-banner.png": "8d69",
	"./monitor-add-container.png": "b9df",
	"./monitor-empty.png": "d7e1",
	"./more-bottom-blue.png": "b024",
	"./more-bottom.png": "b715",
	"./more-icon-blue.png": "8f21",
	"./more-icon.png": "92e9",
	"./more-specs-icon.png": "720b",
	"./more-top-blue.png": "b4c7",
	"./more-top.png": "51c2",
	"./my-activity-icon.png": "1fdf",
	"./my-consult.png": "3539",
	"./my-feedback.png": "bfbf",
	"./my-patient-icon.png": "b81f",
	"./my-wallet-icon.png": "4c31",
	"./myWallet-back.png": "ec8b",
	"./myaudio-play-icon.png": "e55a",
	"./myaudio-stop-icon.png": "aad4",
	"./mygift-back.png": "281b",
	"./noActive-icon.png": "7ee9",
	"./now-patient-icon.png": "f12b",
	"./open-icon.png": "9389",
	"./or-icon.png": "6ed2",
	"./order-Completed.png": "3472",
	"./order-count-icon1.png": "e1e9",
	"./order-count-icon2.png": "88be",
	"./order-count-icon3.png": "174c",
	"./order-count-icon4.png": "2492",
	"./order-head-back1.png": "bcd6",
	"./order-head-back2.png": "730f",
	"./order-head-back3.png": "e9c7",
	"./oriject-select.png": "5323",
	"./overlay-login-back.png": "9113",
	"./ovlay-back.png": "cbca",
	"./pageSet-icon1.png": "5453",
	"./pageSet-icon2.png": "e531",
	"./pageSet-icon3.png": "6ac4",
	"./paper-clip-icon.png": "0a9a",
	"./patient-add-banner.png": "697f",
	"./patient-arrow.png": "39d9",
	"./patient-desc-icon.png": "6617",
	"./patient-empty-img.png": "174a",
	"./patient-gender-man.png": "b0f9",
	"./patient-gender-woman.png": "5a6f",
	"./patient-man-active-icon.png": "fe9a",
	"./patient-man-icon.png": "c961",
	"./patient-title-time.png": "9798",
	"./patient-woman-active-icon.png": "6ff0",
	"./patient-woman-icon.png": "a0eb",
	"./patientList-picman.png": "2d86",
	"./patientList-picwoman.png": "3331",
	"./patienticonAvtive.png": "cace",
	"./pay-result-icon.png": "ea3e",
	"./pay-success-icon.png": "42d3",
	"./people-user-default-pic.png": "8300",
	"./person-icon.png": "0f07",
	"./personal-back.png": "7fea",
	"./personal-icon.png": "7223",
	"./phone-icon.png": "503a",
	"./point.png": "cad7",
	"./progress-back-icon.png": "e1f1",
	"./progress-icon-active.png": "4d17",
	"./progress-icon.png": "f6a1",
	"./project-active.png": "ca99",
	"./project-item-icon.png": "01b8",
	"./project-select-close.png": "99c6",
	"./radiotherapy-detail-head-back.png": "0350",
	"./ratingScale-value-status-icon1.png": "5adf",
	"./ratingScale-value-status-icon2.png": "a46a",
	"./receive-bg.png": "dffa",
	"./recor-clare-icon.png": "f6a2",
	"./rediotherapy-patient-title.png": "e11c",
	"./redpacket-bg.png": "4a5f",
	"./redpacket-bg2.png": "bcb9",
	"./redpacket-line-icon.png": "7113",
	"./redpacket-line-icon1.png": "0e01",
	"./remind-back.png": "eb6a",
	"./remind-back2.png": "1f85",
	"./reserve-active-time-icon.png": "4076",
	"./reserve-success.png": "0865",
	"./reserve-type-icon1.png": "9eec",
	"./reserve-type-icon2.png": "fff2",
	"./reserve-type-icon3.png": "ae9d",
	"./reset-icon.png": "b981",
	"./rotate-icon.png": "abcd",
	"./rule-after-back.png": "2c64",
	"./rule-back.png": "5834",
	"./rule-befor-icon.png": "5ee7",
	"./sales-null-icon.png": "8d67",
	"./score-on.png": "974f",
	"./score.png": "9ffc",
	"./screen-icon-active.png": "9961d",
	"./screen-icon.png": "2d460",
	"./search-icon.png": "249a",
	"./search_name_icon.png": "018d",
	"./search_name_iconnull.png": "1355",
	"./search_phone_icon.png": "33fe",
	"./search_phone_iconnull.png": "f9ca",
	"./see.png": "00ee",
	"./selec-project-icon.png": "0e70",
	"./selectPatient-banner.png": "0513",
	"./service-icon.png": "937f",
	"./setps-arrow.png": "b8f6",
	"./sex-girl.png": "2cb5",
	"./sex-girlbtn-back.png": "4115",
	"./sex-man.png": "f890",
	"./sex-manbtn-back.png": "9e05",
	"./share-arrow-icon.png": "6492",
	"./share-arrow.png": "bf80",
	"./share-doctor.png": "70ee",
	"./share-icon.png": "e33f",
	"./share-im-icon.png": "322b",
	"./share-progress-icob.png": "b2ae",
	"./share-right-icon.png": "67d8",
	"./share-star.png": "f9b6",
	"./share-user-icon.png": "9c9a",
	"./share-wx-icon.png": "6c8e",
	"./shop-cart-icon.png": "6066",
	"./singularA.png": "ea02",
	"./singularB.png": "a1cc",
	"./singularC.png": "5f58",
	"./singularD.png": "b5a1",
	"./singularE.png": "0553",
	"./skilled-icon.png": "8583",
	"./stock-icon.png": "0286",
	"./stow-icon.png": "d550",
	"./subscribe-head-icon.png": "23e2",
	"./subscrubenull.png": "a6e4",
	"./subtitle-back.png": "4a31",
	"./switch-icon.png": "7b5f",
	"./tennat_info_addr.png": "4369",
	"./tennat_info_img.png": "fb48",
	"./tennat_info_tel.png": "b632",
	"./thumbsUp-active.png": "9c7b",
	"./thumbsUp.png": "e4a4",
	"./tick.png": "8816",
	"./time-icon.png": "af11",
	"./title-banner.png": "44f0",
	"./tj_checkCode_icon.png": "6040",
	"./tj_checkCode_iconnull.png": "082b",
	"./tj_close_icon.png": "e344",
	"./tj_duibi_active.png": "8da9",
	"./tj_duibi_bottom_icon.png": "6cb1",
	"./tj_duibi_top_icon.png": "5e44",
	"./tj_head_back_left.png": "cb45",
	"./tj_head_back_right.png": "50cc",
	"./tj_list_item_back.png": "fe25",
	"./tj_search_head_Icon.png": "89e9",
	"./tj_title_left_icon.png": "1dde",
	"./tj_title_right_icon.png": "1faa",
	"./tjcs-main-back.png": "d915",
	"./unclaimed-icon.png": "cb35",
	"./untick.png": "9bea",
	"./upload-img-icon.png": "dc97",
	"./upload-img.png": "c865",
	"./uploadimg-icon.png": "8715",
	"./useMedicine-bg.png": "803d",
	"./useMedicine-icon.png": "dfb1",
	"./used-icon.png": "a8ae",
	"./user-head.png": "b4db",
	"./visitrecord-emtry.png": "930d",
	"./vs-icon.png": "27c7",
	"./waaiticon.png": "dc73",
	"./wan-icon.png": "972a",
	"./warning-icon.png": "0f1c",
	"./withdraw-active.png": "8703",
	"./woman-icon.png": "f04b",
	"./write-icon.png": "1b19",
	"./write-one-icon.png": "cdd4",
	"./youraudio-play-icon.png": "c3c5",
	"./youraudio-stop-icon.png": "c7ab",
	"./yzm-container-back1.png": "762c",
	"./yzm-container-back2.png": "29fd",
	"./zanwutupian.png": "707b",
	"./右边爱心@3x.png": "b9a2",
	"./左边爱心@3x.png": "be12"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";